module.exports = __webpack_public_path__ + "img/icons_36.b4749bf5.svg";